import { Navigate, useLocation, useParams } from "react-router-dom";

/** Хуучин /reconciliation/:id холбоос → /settlement/:id (id нь тооцооны хуудасных хэвээр). */
export const ReconciliationRedirect = () => {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/settlement/${id}${search}`} replace />;
};
